// Constants
import { CompanyName } from '../Constants';

// Small Gallery Images
import Image1 from '../../assets/images/main/mistress-md-professional-dominatrix-main-image.jpg';
import Image2 from '../../assets/images/main/mistress-md-professional-dominatrix-in-black-with-whip.jpg';
import Image3 from '../../assets/images/main/mistress-md-professional-dominatrix-nurse.jpg';
import Image7 from '../../assets/images/main/mistress-md-professional-dominatrix-in-red-with-whip.jpg';
import Image4 from '../../assets/images/main/mistress-md-professional-dominatrix-in-red-in-red-dungeon-smoking.jpg';
import Image5 from '../../assets/images/main/mistress-md-professional-dominatrix-in-pink-boots.jpg';
import Image6 from '../../assets/images/main/mistress-md-professional-dominatrix-blue-boots.jpg';
import Image8 from '../../assets/images/main/mistress-md-professional-dominatrix-blue-boots-on-throne.jpg';

// Large Gallery Images
import LargeImage1 from '../../assets/images/main/mistress-md-professional-dominatrix-main-image.jpg';
import LargeImage2 from '../../assets/images/main/mistress-md-professional-dominatrix-in-black-with-whip.jpg';
import LargeImage3 from '../../assets/images/main/mistress-md-professional-dominatrix-in-red-with-whip.jpg';
import LargeImage4 from '../../assets/images/main/mistress-md-professional-dominatrix-in-red-in-red-dungeon-smoking.jpg';
import LargeImage5 from '../../assets/images/main/mistress-md-professional-dominatrix-in-pink-boots.jpg';
import LargeImage6 from '../../assets/images/main/mistress-md-professional-dominatrix-blue-boots.jpg';
import LargeImage7 from '../../assets/images/main/mistress-md-professional-dominatrix-nurse.jpg';
import LargeImage8 from '../../assets/images/main/mistress-md-professional-dominatrix-blue-boots-on-throne.jpg';
import LargeImage9 from '../../assets/images/main/mistress-md-professional-dominatrix-and-sexy-nurse.jpg';
import LargeImage10 from '../../assets/images/main/mistress-md-professional-dominatrix-sploshing.avif';
import LargeImage11 from '../../assets/images/main/mistress-md-professional-dominatrix-wrestling.avif';
import LargeImage12 from '../../assets/images/main/mistress-md-professional-dominatrix-in-red-in-red-dungeon-smoking-banner.jpg';

// Large Gallery Array
export const largeGalleryImagesArray = [
  {
    id: 1,
    src: LargeImage1,
    alt: `${CompanyName} main image`,
    name: 'Powerful in Pink',
    date: 'March 1, 2025',
  },
  {
    id: 2,
    src: LargeImage2,
    alt: `${CompanyName} playing with friends and a sub`,
    name: 'The Rack Awaits',
    date: 'March 2, 2025',
  },
  {
    id: 3,
    src: LargeImage3,
    alt: `${CompanyName} crouched outside`,
    name: 'Get In The Cage!',
    date: 'March 3, 2025',
  },
  {
    id: 4,
    src: LargeImage4,
    alt: `${CompanyName} with a racked sub in the dungeon`,
    name: 'Smoking Goddess',
    date: 'March 4, 2025',
  },
  {
    id: 5,
    src: LargeImage5,
    alt: `${CompanyName} with a sub on the cross`,
    name: 'You Are Next!',
    date: 'March 5, 2025',
  },
  {
    id: 6,
    src: LargeImage6,
    alt: `${CompanyName} in a garden`,
    name: 'Spanking Throne',
    date: 'March 6, 2025',
  },
  {
    id: 7,
    src: LargeImage7,
    alt: `${CompanyName} in the kitchen with stockings`,
    name: 'Nurse Is In!',
    date: 'March 7, 2025',
  },
  {
    id: 8,
    src: LargeImage8,
    alt: `${CompanyName} in the kitchen`,
    name: 'Worship Me!',
    date: 'March 8, 2025',
  },
  {
    id: 9,
    src: LargeImage9,
    alt: `${CompanyName} in sexy nurse outfit`,
    name: 'Just A Small Prick!',
    date: 'March 9, 2025',
  },
  {
    id: 10,
    src: LargeImage10,
    alt: `${CompanyName} in sploshing action`,
    name: 'Sploshing Action',
    date: 'March 10, 2025',
  },
  {
    id: 11,
    src: LargeImage11,
    alt: `${CompanyName} wrestling pose`,
    name: 'Wrestling Empress',
    date: 'March 11, 2025',
  },
];

// Image Data Array
export const smallGalleryImagesArray = [
  {
    id: 1,
    src: Image1,
    name: 'Main Mistress Portrait',
    alt: `${CompanyName} in a striking dominatrix pose`,
    ariaLabel: 'Gallery image 1',
    description: 'Commanding, bold, and unforgettable',
  },
  {
    id: 2,
    src: Image2,
    name: 'The Whip Mastery',
    alt: `${CompanyName} exuding power with a whip`,
    ariaLabel: 'Gallery image 2',
    description: 'Poised, elegant, and powerful',
  },
  {
    id: 3,
    src: Image3,
    name: 'Dungeon Domination',
    alt: `${CompanyName} asserting her presence in a dungeon setting`,
    ariaLabel: 'Gallery image 4',
    description: 'Intimidating, powerful, and fearless',
  },
  {
    id: 4,
    src: Image4,
    name: 'Seductive Nurse',
    alt: `${CompanyName} striking a medical-inspired dominatrix look`,
    ariaLabel: 'Gallery image 7',
    description: 'Alluring, confident, and in charge',
  },
];
